var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A2A6A8",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "#A2A6A8",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: "M2.3243240536870218,7.999999884012587 L13.675675405038383,7.999999884012587",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapSolid);
export default __webpack_public_path__ + "static/media/cap_solid.5a7463f0158e87e71a2d06975bc1080b.svg";
export { ForwardRef as ReactComponent };